export default {
  name: 'PageNotFound',
  data () {
    console.log('route',this.$route);
    return {
      page: this.$route
    }
  }
}
